import { GeneralService } from './../../../services/general.service';
import { FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';


export class FormPc003Build {

    public buildForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): FormGroup {
        this.buildFormI(form, arrForm[0], generalService);
        return form;
    }

    private buildFormI(form: FormGroup, formCard: FormGroup, generalService: GeneralService): FormGroup {
        form.get('contrato_juridico').setValue(formCard.get('contrato_juridico')?.value);
        form.get('cooperante').setValue(formCard.get('cooperante')?.value);
        form.get('hibrido_rnc').setValue(formCard.get('hibrido_rnc')?.value);
        form.get('site_origem').setValue(formCard.get('site_origem')?.value);
        form.get('distancia_campo').setValue(formCard.get('distancia_campo')?.value);
        form.get('gleba').setValue(formCard.get('gleba')?.value);
        form.get('especie').setValue(formCard.get('especie')?.value);
        form.get('tipo_colheita').setValue(formCard.get('tipo_colheita')?.value);
        form.get('numero_campo').setValue(formCard.get('numero_campo')?.value);
        form.get('safra').setValue(formCard.get('safra')?.value);
        form.get('ano').setValue(formCard.get('ano')?.value);
        form.get('jit').setValue(formCard.get('jit')?.value);
        form.get('contrato_torre').setValue(formCard.get('contrato_torre')?.value);
        form.get('geracao').setValue(formCard.get('geracao')?.value);
        form.get('origem_contrato').setValue(formCard.get('origem_contrato')?.value);
        form.get('janela_plantio').setValue(formCard.get('janela_plantio')?.value);
        form.get('ambiente').setValue(formCard.get('ambiente')?.value);
        form.get('site_recebimento').setValue(formCard.get('site_recebimento')?.value);

        return form;
    }


    public updateForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): void {
        this.updateFormI(form, arrForm[0], generalService);
    }

    private updateFormI(data: any, formCard: FormGroup, generalService: GeneralService): void {
        formCard.get('contrato_juridico').setValue(data.contrato_juridico);
        formCard.get('cooperante').setValue(data.cooperante);
        formCard.get('hibrido_rnc').setValue(data.hibrido_rnc);
        formCard.get('site_origem').setValue(data.site_origem);
        formCard.get('gleba').setValue(data.gleba);
        formCard.get('distancia_campo').setValue(data.distancia_campo);
        formCard.get('especie').setValue(data.especie);
        formCard.get('tipo_colheita').setValue(data.tipo_colheita);
        formCard.get('numero_campo').setValue(data.numero_campo);
        formCard.get('safra').setValue(data.safra);
        formCard.get('ano').setValue(data.ano);
        formCard.get('jit').setValue(data.jit);
        formCard.get('contrato_torre').setValue(data.contrato_torre);
        formCard.get('geracao').setValue(data.geracao);
        formCard.get('origem_contrato').setValue(data.origem_contrato);
        formCard.get('janela_plantio').setValue(data.janela_plantio);
        formCard.get('ambiente').setValue(data.ambiente);
        formCard.get('site_recebimento').setValue(data.site_recebimento);
    }

 
}
